export default __webpack_public_path__ + "static/media/s1.7b0e1dc5.jpg";